import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';
import {ProvisionAgentCoverageDto} from '../../model/dto/api/provision-agent-coverage.dto';

/**
 * Custom API service for the LIVE cover read of ONE Abrechnungskonto (`cp.ProvisionAgent`).
 *
 * Base URL `/mvsa/cp/provisionAgents` — the same route the alias `cp.ProvisionAgent` carries in
 * cp.entity-provider.ts. Shape follows the sibling action services of this module
 * ({@link CpProvisionRunService}, {@link CpProvisionContractAgentService}): an `MvsCrudService`
 * subclass whose only job is the custom endpoints of that route, while the generic CRUD of the
 * alias keeps going through the registry service.
 *
 * READ-ONLY. The endpoint computes nothing new: it runs
 * `ProvisionReserveCoverageService.computeForAgent(id)`, which is the same aggregation and the same
 * two formulas the provision run writes its `cp.ProvisionAgentReserveCoverage` history with. LIVE
 * and HISTORY are one formula over one data basis (FD-1); a dashboard refresh is not a run and
 * writes nothing.
 */
@Injectable({
    providedIn: 'root'
})
export class CpProvisionAgentCoverageService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cp/provisionAgents');
    }

    /**
     * GET /{id}/coverage — the four live figures of one Abrechnungskonto.
     *
     * `coverageQuote` is NULLABLE and callers MUST treat it as such: it is null exactly when the
     * account carries no open liability at all. Rendering 0 % or 100 % in that case would claim
     * something about a risk that does not exist.
     *
     * @param provisionAgentId id of the Abrechnungskonto (`cp.ProvisionAgent`)
     */
    public getCoverage(provisionAgentId: number): Observable<ProvisionAgentCoverageDto> {
        return this.http.get<ProvisionAgentCoverageDto>(this.apiUrl + `/${provisionAgentId}/coverage`);
    }

}
